<template>
  <router-view />
</template>

<script setup lang="ts">
// Main App component - routes will be rendered here
</script>
